<template>
  <v-select
    :class="`BgSelect ${extraWide && 'extra-wide'} ${createNew && 'taggable'}`"
    :clearable="clearable"
    :searchable="searchable"
    :multiple="multiple"
    ref="selectInput"
    :options="options"
    :components="{ OpenIndicator }"
    :create-option="(tag) => tag"
    v-model="selected"
    :taggable="createNew"
    :open="true"
    :label="label"
    v-bind="{ placeholder }"
    :loading="loading"
  >
  </v-select>
</template>

<style scoped>
@import "./styles.css";
</style>

<script>
import vSelect from "vue-select";
import BgIcon from "../bg-icon";
import "vue-select/src/scss/vue-select.scss";
export default {
  name: "BgSelect",
  components: {
    BgIcon,
    vSelect,
  },
  props: {
    placeholder: {
      type: String,
    },
    value: {
      default: "",
    },
    name: {
      type: String,
      value: "",
    },
    options: Array,
    modalValue: Object,
    extraWide: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: String,
    searchable: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    createNew: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    selected: function() {
      this.$emit("input", this.selected);
      this.$emit("change", this.selected);
    },
    value(value) {
      this.selected = value;
    },
  },
  data() {
    return {
      OpenIndicator: {
        render: () => <bg-icon name="chevronDown" />,
      },
      selected: this.value,
    };
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.selectInput.focus();
    }
  },
  methods: {
    resetInsightSelect() {
      if (this.selected) {
        this.selected = null;
      }
    },
  },
};
</script>
